// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";
import { getShipTos, GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { ShipToCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { CustomAppState } from "@pacific/App/Store/Reducers";

export type XngGetShipTosApiParameter = GetShipTosApiParameter & {
    onlySavedAddresses?: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<
    {},
    XngGetShipTosApiParameter,
    ShipToCollectionModel,
    {
        newShipTo?: ShipToModel;
        dataViewParameter: GetShipTosApiParameter;
    }
>;

export const DispatchBeginLoadShipTos: HandlerType = props => {
    const state = props.getState() as CustomAppState;
    props.dataViewParameter = state.xCompanySavedAddresses.getShipTosParameter;
    props.dispatch({
        type: "xCompanySavedAddresses/BeginLoadShipTos",
        parameter: props.dataViewParameter,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    const timestamp = `time${new Date().getTime()}`;
    props.apiParameter = { 
        ...props.dataViewParameter,
        onlySavedAddresses: true,
        timestamp,
    } as any;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getShipTos(props.apiParameter);
};

export const CleanupData: HandlerType = props => {
    const newShipTo = props.apiResult.shipTos!.find(o => o.isNew);
    props.apiResult.shipTos = props.apiResult.shipTos!.filter(o => !o.isNew);
    props.newShipTo = newShipTo;
};

export const DispatchSetNewShipTo: HandlerType = props => {
    props.dispatch({
        type: "Pages/Addresses/SetNewShipTo",
        newShipTo: props.newShipTo,
    });
};

export const DispatchCompleteLoadShipTos: HandlerType = props => {
    props.dispatch({
        type: "xCompanySavedAddresses/CompleteLoadShipTos",
        collection: props.apiResult,
        parameter: props.dataViewParameter,
    } as any);
};

export const chain = [
    DispatchBeginLoadShipTos,
    PopulateApiParameter,
    RequestDataFromApi,
    CleanupData,
    DispatchSetNewShipTo,
    DispatchCompleteLoadShipTos,
];

const loadCompanySavedAddresses = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadCompanySavedAddresses");
export default loadCompanySavedAddresses;
